module.exports = __webpack_public_path__ + "static/img/other.ccc8a510.png";